import React from 'react';
import { motion } from 'framer-motion';
import logo from '../../Assets/logo.png';
import { Link } from 'react-router-dom';
import AdSense from 'react-adsense';

const PageHome = () => {
  const buttonVariants = {
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.5,delay: 1 } },
  };

  return (
    <div className="d-flex text-center">


<AdSense.Google
  client='ca-pub-7864949572024333'
  slot='2564562231'
/>

    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      
      
    >
      <div className="px-4 py-5 my-5 text-center">
        <motion.img
          initial={{ scale: 0 }}
          animate={{ scale: 2 }}
          transition={{ duration: 0.5 }}
          className="d-block mx-auto mb-4"
          src={logo}
          alt=""
          width="102"
          height="87"
        />
        <motion.h1
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="display-5 fw-bold"
        >
          <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7864949572024333"
     crossorigin="anonymous"></script>

   
          Egzaminy Zawodowe INF
        </motion.h1>
        <div className="col-lg-6 mx-auto">
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="lead mb-4"
          >
            Przygotuj się do egzaminów zawodowych z informatyki dzięki naszym
            zasobom edukacyjnym. Oferujemy przykładowe zadania, szczegółowe
            rozwiązania oraz materiały pomocnicze, które pomogą Ci osiągnąć
            sukces na egzaminie.
          </motion.p>

          <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
            <Link to="/egzaminy">
              <motion.button
                variants={buttonVariants}
                initial="initial"
                animate="animate"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                type="button"
                className="btn btn-primary btn-lg px-4 gap-3"
              >
                Egzaminy
              </motion.button>
            </Link>
            <Link to="/contact">
              <motion.button
                variants={buttonVariants}
                initial="initial"
                animate="animate"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                type="button"
                className="btn btn-outline-secondary btn-lg px-4"
              >
                Kontakt
              </motion.button>
            </Link>
            <Link to="/materialy">
              <motion.button
                variants={buttonVariants}
                initial="initial"
                animate="animate"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                type="button"
                className="btn btn-info btn-lg px-4 text-light"
              >
                Materiały
              </motion.button>
            </Link>
          </div>
        </div>
      </div>
    </motion.div>
    </div>
  );
};

export default PageHome;
